import { React, Component } from "react";
export default function logo() {
    return (
        <>
            <div id="logo1">
                <div id="logo2">
                <div class="logo">
                    <img src="logo.png" alt="Your Logo" />
                    <h1>GradeSys</h1>
                </div>
                </div>
            </div>
        </>
    )
}


